(function(){
	'use strict';
	angular.module('app.leanProjects')
		.controller('individualPerformance', individualPerformance);

	individualPerformance.$inject = ['$rootScope', '$scope', '$state', '$location', '$timeout', '$window', '$uibModal', 'leanFilterService',
		'tableRenderService', 'tableService', 'storeService', 'redirectParamsService', '$experiments'];

	function individualPerformance($rootScope, $scope, $state, $location, $timeout, $window, $uibModal, leanFilterService,
			tableRenderService, tableService, storeService, redirectParamsService, $experiments) {
		var vm = this;
		var unsubscribe;
		var reportSettingsName = 'individual-performance';
		// Extra query params to send to backend in data requests
		var extraParams = [{'excelReportName': 'LeanProject/IndividualPerformance'}];
		var rendererParams = {};
		// Extra drilldown query params to parse
		var extraFilters = [];
		var pinnedColumns = [];
		var defaultFilters = [];

		$scope.filterService = leanFilterService;

		//Set correct navigation highlighting
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.showExcel = true;
		vm.showTaskProgressSummary = true;
		vm.showChart = showChart;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		vm.reportName = 'Individual performance (Lean projects)';
		$scope.dataReady = false;
		var responseData = undefined;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				responseData = response[0].data;
				$scope.dataReady = true;
				return response;
			});
		}

		init();

		var columns =[
			{
				id: 'responsible',
				display: 'Responsible',
				width: 240
			},
			{
				id: 'totalProjectsManaged',
				customHeaderClass: 'table-header-1',
				display: 'Projects: Total Managed',
				ndxField: 'responsibleNdx',
				renderer: tableRenderService.integerWithLink,
				sortDefaultReverse: true,
				width: 120,
				urlGenerator: urlGenerator
			},
			{
				id: 'totalProjectsInvolved',
				customHeaderClass: 'table-header-1',
				display: 'Projects: Total Involved',
				ndxField: 'responsibleNdx',
				renderer: tableRenderService.integerWithLink,
				width: 120,
				urlGenerator: urlGenerator
			},
			{
				id: 'percentOfProjectsCompleted',
				customHeaderClass: 'table-header-1',
				display: 'Projects: Percent Complete',
				renderer: tableRenderService.percent,
				width: 120
			},
			{
				id: 'totalTasksAssigned',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Total Assigned',
				ndxField: 'responsibleNdx',
				renderer: tableRenderService.integerWithLink,
				width: 120,
				urlGenerator: urlGenerator
			},
			{
				id: 'percentOfTasksCompleted',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Percent Complete',
				renderer: tableRenderService.percent,
				width: 120
			},
			{
				id: 'tasksPending',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Pending',
				renderer: tableRenderService.integer,
				width: 120
			},
			{
				id: 'tasksStarted',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Started',
				renderer: tableRenderService.integer,
				width: 120
			},
			{
				id: 'tasksCompleted',
				customHeaderClass: 'table-header-2',
				display: 'Tasks: Completed',
				renderer: tableRenderService.integer,
				width: 120
			}
		];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/LeanProject/IndividualPerformance',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'totalProjectsManaged',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			hideSearch: true,
			hideEdit: true,
			setColumnDefaults: true,
			excelRequest: true,
			waitForFilters: true
		};

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = vm.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function urlGenerator(type, ndx) {
			var url = '';
			var factories = leanFilterService.getFactoryList();
			if (type === 'totalProjectsManaged') {
				url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1&timePeriod=all&projectManagerId=' + ndx + '&factory=' + factories;
			} else if (type === 'totalProjectsInvolved') {
				url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1&timePeriod=all&projectInvolvedId=' + ndx + '&factory=' + factories;
			} else if (type === 'totalTasksAssigned') {
				url =  '/application/f/home.html#/lean-projects/view-tasks/?drilldown=1&responsibleId=' + ndx + '&factory=' + factories;
			}
			var qParamList = leanFilterService.getQueryParam();
			for (var i = 0; i < qParamList.length; i++) {
				if (qParamList[i].key !== 'stageIdNoStatic' && !(type === 'totalProjectsManaged' && qParamList[i].key === 'projectManagerId')) {
					url += '&' + qParamList[i].key + '=' + qParamList[i].value;
				}
			}
			var selectedStages = leanFilterService.getSelectedIds('stageIdNoStatic');
			if (selectedStages && selectedStages.length === 1 && selectedStages[0] === 'LDNA_A_S') {
				selectedStages = [];
			}
			if (!selectedStages || selectedStages.length === 0) {
				var stages = leanFilterService.getFilterById('stageIdNoStatic').objectList;
				for (var i = 0; i < stages.length; i++) {
					selectedStages.push(stages[i].id);
				}
			}
			if (type === 'totalProjectsManaged' || type === 'totalProjectsInvolved'){
				url += '&projectStageId=' + selectedStages.toString();
			} else if (type === 'totalTasksAssigned') {
				url += '&stageIdNoStatic=' + selectedStages.toString();
			}
			return url;
		}

		function showChart() {
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: '/application/f/lean-projects/reports/individual-performance-chart.html',
				windowTemplateUrl: '/application/f/lean-projects/reports/individual-performance-chart-window.html',
				controller: 'individualPerformanceChartCtrl',
				resolve: {
					rawChartData: function() {
						return responseData;
					}
				}
			});
		}


		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: false});
		}

		function init() {
			$scope.filterService.clearFilters();
			leanFilterService.useFactoryFilter = true;
			defaultFilters = [
				{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true },
				{ 'id': 'projectArea', 'values': [$scope.filterService.leanDnaAllSelected] },
				{ 'id': 'role', 'values': [$scope.filterService.leanDnaAllSelected] }
			];
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);
			var filters = [
				siteFilter,
				$scope.filterService.filterDefinitions.ProjectArea,
				$scope.filterService.filterDefinitions.ProjectCategories,
				$scope.filterService.filterDefinitions.ProjectManager,
				$scope.filterService.filterDefinitions.ProjectStageNoStatic,
				$scope.filterService.filterDefinitions.ProjectTypes,
				$scope.filterService.filterDefinitions.ProjectGoals,
				$scope.filterService.filterDefinitions.RoleType
			];
			$scope.filterService.setMasterFilterList(filters);
			$scope.filterService.setMasterSingleSelectFilterList([]);
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

	}
})();